(async () => {
  const caseId = new URLSearchParams(location.search).get("case"),
    form = document.getElementById("ContactUsForm");
  if (!caseId || !form) return;
  const simulation = caseId.startsWith('SIM-') || new URLSearchParams(location.search).get('simulation') === '1';
  let copy = {};
  try { copy = JSON.parse(document.querySelector('[data-case-inquiry-copy]')?.textContent || '{}'); } catch {}
  const status = form.querySelector("[data-case-inquiry-status]");
  status.hidden = false;
  status.textContent = copy.loading;
  const card = form.querySelector('[data-case-inquiry-card]');
  // Match the AI Records overall-slot selection, without loading its page controller.
  const mainImage = record => {
    const array = value => Array.isArray(value) ? value : [];
    const images = array(record.displayImages || record.images);
    const fallbackRoles = images.length >= 5
      ? ['MAIN_EFFECT_IMAGE','PRODUCT_IMAGE','USAGE_SCENE_IMAGE','BRAND_MARK_DETAIL_IMAGE','PACKAGING_IMAGE']
      : ['PRODUCT_IMAGE','USAGE_SCENE_IMAGE','PRODUCT_DETAIL_IMAGE','PACKAGING_IMAGE'];
    const roles = Number(record.flowVersion) >= 2 ? ['MAIN_EFFECT_IMAGE','PRODUCT_IMAGE'] : ['PRODUCT_IMAGE','MAIN_EFFECT_IMAGE'];
    const roleOf = (image, index) => {
      if (['MAIN_EFFECT_IMAGE','PRODUCT_IMAGE','USAGE_SCENE_IMAGE','PRODUCT_DETAIL_IMAGE','BRAND_MARK_DETAIL_IMAGE','PACKAGING_IMAGE','GIFT_BOX_IMAGE'].includes(image.role)) return image.role;
      const label = String(image.label || '').toLowerCase();
      if (/pack|礼盒|包装/.test(label)) return 'PACKAGING_IMAGE';
      if (/scene|usage|场景/.test(label)) return 'USAGE_SCENE_IMAGE';
      if (/brand|logo|唛|品牌/.test(label)) return 'BRAND_MARK_DETAIL_IMAGE';
      if (/detail|细节|材质|包边/.test(label)) return 'PRODUCT_DETAIL_IMAGE';
      if (/main|主/.test(label)) return 'MAIN_EFFECT_IMAGE';
      if (/product|产品/.test(label)) return 'PRODUCT_IMAGE';
      return fallbackRoles[index];
    };
    const slot = array(record.currentGeneration?.previewSlots).find(item => item.slot === 'overall');
    if (slot?.skipped || slot?.errorCode === 'PREVIEW_SKIPPED') return '';
    let image;
    if (slot) {
      image = images.find(item => slot.assetId && item.assetId === slot.assetId);
      if (!image && /^(SUCCEEDED|SUCCESS|COMPLETED)$/.test(String(slot.status))) image = images.find((item,index) => roles.includes(roleOf(item,index)));
    } else {
      for (const role of roles) { image = images.find((item,index) => roleOf(item,index) === role); if (image) break; }
      if (!image) image = array(record.assets).find(item => item.isCurrent !== false && roles.includes(item.role));
    }
    return slot?.asset?.publicUrl || image?.url || image?.asset?.publicUrl || '';
  };
  if (simulation) {
    form.removeAttribute('data-shopify-captcha');
    form.addEventListener('submit', event => {
      event.preventDefault(); event.stopImmediatePropagation();
      status.textContent = copy.simulation_sent;
      status.scrollIntoView({block:'nearest',behavior:'smooth'});
    }, true);
  }
  try {
    const client = simulation ? window.PoptexGenerationSimulation?.client() : window.PoptexApi.getDefaultClient();
    if (!client) throw new Error('Test workflow unavailable');
    await client.storefront.refreshCustomerSession();
    const result = await client.cases.get(caseId),
      record = result.case || (result.data?.id ? result.data : result),
      c = record.caseConfig || {};
    if (!record.id) throw new Error("Missing record");
    form.querySelector("[data-inquiry-case-number]").value =
      record.caseNo || record.id;
    const summary =
      record.flowVersion === 2
        ? [
            c.productSeries?.name,
            c.size ? `${c.size.widthInches} × ${c.size.heightInches} in` : null,
            ...Object.entries(c.surfaces || {}).map(
              ([side, value]) =>
                `${side}: ${value.pattern?.name || value.uploadName || value.name || "Uploaded artwork"}`,
            ),
            `Branding: ${[...(c.branding?.texts || []).map((t) => t.text), c.branding?.mark?.type].filter(Boolean).join(" / ") || "None"}`,
            `Edging: ${c.edging?.name || "Default"}`,
            `Packaging: ${c.packaging?.name || "None"}`,
          ]
            .filter(Boolean)
            .join("; ")
        : record.title || "Historical Case; see the result link";
    form.querySelector("[data-inquiry-summary]").value = summary;
    const url = new URL(document.querySelector('[data-contact-page]')?.dataset.contactRecordsUrl || '/pages/ai-records', location.origin);
    url.searchParams.set("case", record.id);
    if (simulation) url.searchParams.set('simulation','1');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    form.querySelector("[data-inquiry-result-link]").value = url.href;
    const subject = form.querySelector('[name="contact[Subject]"]');
    if (!subject.value) subject.value = 'Custom quote';
    for (const hook of ['data-inquiry-case-number', 'data-inquiry-summary', 'data-inquiry-result-link']) form.querySelector(`[${hook}]`).disabled = false;
    if (card) {
      const productName = c.productSeries?.name || record.configuration?.product || c.display?.product || record.title || copy.record_title;
      const dimensions = c.size || record.configuration?.size || c.display?.size || record.size;
      const size = typeof dimensions === 'string' ? dimensions.replace(/(\d)\s*x\s*(\d)/i, '$1 × $2')
        : Number(dimensions?.widthInches) > 0 && Number(dimensions?.heightInches) > 0 ? `${dimensions.widthInches} × ${dimensions.heightInches} in` : '';
      card.querySelector('[data-case-inquiry-title]').textContent = productName;
      card.querySelector('[data-case-inquiry-number]').textContent = record.caseNo || record.id;
      card.querySelector('[data-case-inquiry-number-row]').hidden = !(record.caseNo || record.id);
      card.querySelector('[data-case-inquiry-size]').textContent = size;
      card.querySelector('[data-case-inquiry-size-row]').hidden = !size;
      const image = card.querySelector('[data-case-inquiry-image]');
      image.alt = productName;
      window.PoptexTemplateContent?.setImage(image, card.querySelector('[data-case-inquiry-placeholder]'), mainImage(record));
      card.querySelector('[data-case-inquiry-link]').href = url.href;
      card.hidden = false;
    }
    status.hidden = !simulation;
    status.textContent = simulation ? copy.simulation_loaded.replace('{number}',record.caseNo || record.id) : copy.loaded.replace('{number}', record.caseNo || record.id);
  } catch {
    if (card) card.hidden = true;
    for (const hook of ['data-inquiry-case-number', 'data-inquiry-summary', 'data-inquiry-result-link']) {
      const input = form.querySelector(`[${hook}]`);
      input.value = '';
      input.disabled = true;
    }
    status.textContent = simulation ? copy.simulation_unavailable : copy.unavailable;
  }
})();
